import { formatNumber, isNotDefined } from '@enterprise/core';

/**
 * Formats a number according to the specified number of decimal places.
 * Returns a fallback string if the value is not defined.
 *
 * @param value - The number to format. If undefined or null, the fallback is returned.
 * @param decimals - The number of decimal places to display.
 * @param fallback - The string to return if the value is not defined. Defaults to '?'.
 * @returns The formatted number as a string, or the fallback if the value is not defined.
 */
export const useNumberFormat = (value?: number, decimals?: number, fallback = '?'): string => {
  if (isNotDefined(value)) {
    return fallback;
  }

  return formatNumber(value, {
    settings: {
      maximumFractionDigits: decimals,
      minimumFractionDigits: decimals,
    },
  });
};
